// extracted by mini-css-extract-plugin
export default {"container":"PuzzlesPage_container__TrLm4","list":"PuzzlesPage_list__93Jrg","content":"PuzzlesPage_content__nWbG5"};